'use strict';

exports.__esModule = true;
exports.PageActions = exports.TRACK_VIEW_PRACTICE_PROFILE = exports.LOAD_PRACTICE_REVIEWS = exports.ENABLE_SCROLL_HIGHLIGHT = exports.DISABLE_SCROLL_HIGHLIGHT = exports.TOGGLE_LIKE = exports.CLOSE_MODAL = exports.SUBMIT_FORM = exports.APPLY_PROMO_CODE = exports.UPDATE_PROMO_CODE = exports.UPDATE_PAYLOAD = exports.UPDATE_SPECIALISTS = exports.TOGGLE_SECTION = exports.BOOK_SELECTED_PACKAGE = exports.LOAD_PRACTICE_PROFILE = exports.INIT_LOADED = exports.LOAD_URI = undefined;

var _doctifyUtils = require('doctify-utils');

var LOAD_URI = exports.LOAD_URI = 'PRACTICE_PAGE_ACTIONS:LOAD_URI'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var INIT_LOADED = exports.INIT_LOADED = 'PRACTICE_PAGE_ACTIONS:INIT_LOADED';
var LOAD_PRACTICE_PROFILE = exports.LOAD_PRACTICE_PROFILE = 'PRACTICE_PAGE_ACTIONS:LOAD_PRACTICE_PROFILE';
var BOOK_SELECTED_PACKAGE = exports.BOOK_SELECTED_PACKAGE = 'PRACTICE_PAGE_ACTIONS:BOOK_SELECTED_PACKAGE';
var TOGGLE_SECTION = exports.TOGGLE_SECTION = 'PRACTICE_PAGE_ACTIONS:TOGGLE_SECTION';
var UPDATE_SPECIALISTS = exports.UPDATE_SPECIALISTS = 'PRACTICE_PAGE_ACTIONS:UPDATE_SPECIALISTS';
var UPDATE_PAYLOAD = exports.UPDATE_PAYLOAD = 'PRACTICE_PAGE_ACTIONS:UPDATE_PAYLOAD';
var UPDATE_PROMO_CODE = exports.UPDATE_PROMO_CODE = 'PRACTICE_PAGE_ACTIONS:UPDATE_PROMO_CODE';
var APPLY_PROMO_CODE = exports.APPLY_PROMO_CODE = 'PRACTICE_PAGE_ACTIONS:APPLY_PROMO_CODE';
var SUBMIT_FORM = exports.SUBMIT_FORM = 'PRACTICE_PAGE_ACTIONS:SUBMIT_FORM';
var CLOSE_MODAL = exports.CLOSE_MODAL = 'PRACTICE_PAGE_ACTIONS:CLOSE_MODAL';
var TOGGLE_LIKE = exports.TOGGLE_LIKE = 'PRACTICE_PAGE_ACTIONS:TOGGLE_LIKE';
var DISABLE_SCROLL_HIGHLIGHT = exports.DISABLE_SCROLL_HIGHLIGHT = 'PRACTICE_PAGE_ACTIONS:DISABLE_SCROLL_HIGHLIGHT';
var ENABLE_SCROLL_HIGHLIGHT = exports.ENABLE_SCROLL_HIGHLIGHT = 'PRACTICE_PAGE_ACTIONS:ENABLE_SCROLL_HIGHLIGHT';
var LOAD_PRACTICE_REVIEWS = exports.LOAD_PRACTICE_REVIEWS = 'PRACTICE_PAGE_ACTIONS:LOAD_PRACTICE_REVIEWS';
var TRACK_VIEW_PRACTICE_PROFILE = exports.TRACK_VIEW_PRACTICE_PROFILE = 'PRACTICE_PAGE_ACTIONS:LOAD_PRACTICE_REVIEWS';

var PageActions = exports.PageActions = {
	trackViewsFromSearch: function trackViewsFromSearch(practiceId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'practices/' + practiceId + '/track_views_from_search',
			method: 'PUT',
			actionType: TRACK_VIEW_PRACTICE_PROFILE,
			xhrConfig: xhrConfig
		});
	},
	loadPracticeProfile: function loadPracticeProfile(practiceId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'practices/' + practiceId,
			method: 'GET',
			actionType: LOAD_PRACTICE_PROFILE,
			xhrConfig: xhrConfig
		});
	},
	toggleLike: function toggleLike(_ref) {
		var id = _ref.id,
		    author = _ref.author,
		    auth = _ref.auth;
		return (0, _doctifyUtils.createAction)({
			url: 'reviews/' + id + '/likes',
			method: 'PUT',
			auth: auth,
			data: { author: author, id: id },
			actionType: TOGGLE_LIKE,
			actionData: id
		});
	},
	loadPracticeReviews: function loadPracticeReviews(practiceId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'practices/' + practiceId + '/reviews',
			method: 'GET',
			actionType: LOAD_PRACTICE_REVIEWS,
			xhrConfig: xhrConfig
		});
	},
	loadUri: function loadUri(uri) {
		return {
			type: LOAD_URI,
			uri: uri
		};
	},
	initLoaded: function initLoaded() {
		return {
			type: INIT_LOADED
		};
	},
	toggleSection: function toggleSection(sectionExpanded, sectionName) {
		return {
			type: TOGGLE_SECTION,
			sectionExpanded: sectionExpanded,
			sectionName: sectionName
		};
	},
	updateSpecialists: function updateSpecialists(specialty) {
		return {
			type: UPDATE_SPECIALISTS,
			specialty: specialty
		};
	},
	bookSelectedPackage: function bookSelectedPackage(packageData) {
		return {
			type: BOOK_SELECTED_PACKAGE,
			packageData: packageData
		};
	},
	updatePayload: function updatePayload(property, newValue) {
		return {
			type: UPDATE_PAYLOAD,
			property: property,
			newValue: newValue
		};
	},
	updatePromoCode: function updatePromoCode(newValue) {
		return {
			type: UPDATE_PROMO_CODE,
			newValue: newValue
		};
	},
	applyPromoCode: function applyPromoCode() {
		return {
			type: APPLY_PROMO_CODE
		};
	},
	submitForm: function submitForm() {
		return {
			type: SUBMIT_FORM
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE_MODAL
		};
	},
	disableScrollHighlight: function disableScrollHighlight() {
		return {
			type: DISABLE_SCROLL_HIGHLIGHT
		};
	},
	enableScrollHighlight: function enableScrollHighlight() {
		return {
			type: ENABLE_SCROLL_HIGHLIGHT
		};
	}
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/actions/page-actions.js